import { CmStreamType } from '../cta/CmStreamType.js';

/**
 * Common Media Client Data Stream Type
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */
export const CmcdStreamType = CmStreamType as typeof CmStreamType;

/**
 * @beta
 */
export type CmcdStreamType = CmStreamType;
